// Some keys are reserved in particular implementations,
// for example, `view` is reserved in datadog logger
export var ForbiddenKeys;
(function (ForbiddenKeys) {
    ForbiddenKeys["view"] = "view";
})(ForbiddenKeys || (ForbiddenKeys = {}));
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=types.js.map